import $axios from '../services/api.js'

const state = () => ({
    setting: {
        year: 0,
        semester: 0
    },
    grade: [],
    subject: [],
    // page: 1,
    performances: {}
})

const mutations = {
    ASSIGN_SETTING(state, payload) {
        state.setting = {...state.setting, ...payload}
    },

    ASSIGN_GRADE(state, payload) {
        state.grade = payload
    },

    ASSIGN_SUBJECT(state, payload) {
        state.subject = payload
    },

    ASSIGN_PERFORMANCES(state, payload) {
        state.performances = payload
    },

    // SET_PAGE(state, payload) {
    //     state.page = payload
    // },
}

const actions = {
    getSetting({ commit }) {
        return new Promise((resolve) => {
            $axios.get(`api/teacher/data/setting`)
                .then((response) => {
                    commit('ASSIGN_SETTING', response.data.data)
                    resolve(response.data)
                })
        })
    },
    getGrade({ commit }) {
        return new Promise((resolve) => {
            $axios.get(`api/teacher/data/grade`)
                .then((response) => {
                    commit('ASSIGN_GRADE', response.data.data)
                    resolve(response.data)
                })
        })
    },
    getSubject({ commit }) {
        return new Promise((resolve) => {
            $axios.get(`api/teacher/data/subject`)
                .then((response) => {
                    commit('ASSIGN_SUBJECT', response.data.data)
                    resolve(response.data)
                })
        })
    },
    getPerformances({ commit }) {
        return new Promise((resolve) => {
            $axios.get(`api/teacher/data/performances`)
                .then((response) => {
                    commit('ASSIGN_PERFORMANCES', response.data.data)
                    resolve(response.data)
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}